// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const Tab = ({
  className = ''
}) => null;
//# sourceMappingURL=Tab.js.map